/*
 * FILE IS AUTOMATICALLY GENERATED
 * Last execution 2026-11-05T15:18:51.827Z
 */

import { LicenseScope } from '@common-lib';

export const scope: LicenseScope = 'APP'

export type LicenseType =
  | 'appPushNotifications'
  | 'hidePrice'
  | 'news'
  | 'siteUnitMenuGen1'
  | 'stampCards'
  | 'vouchers';

export type ActiveLicenses = Partial<Record<LicenseType, boolean>>;

/** Before licenses have initialized they will use these values */
export const defaultLicenses: ActiveLicenses = {
  'appPushNotifications': false,
  'hidePrice': false,
  'news': false,
  'siteUnitMenuGen1': false,
  'stampCards': false,
  'vouchers': false,
};
